import { Select } from '@mantine/core';
import { map } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { sendRequest } from '../../services/services';

const CountryCodeSelect = (props) => {
  const [countryData, setCountryData] = useState([]);

  useEffect(() => {
    sendRequest('users/get-country-code', 'get').then((res) => {
      setCountryData(res?.data);
    });
  }, []);

  const SelectCountryCode = useMemo(
    () => (
      <Select
        placeholder="Pick one"
        data={map(countryData, (country) => ({
          key: `${country?.id}`,
          label: `${country?.dial_code}-${country?.name}`,
          // label: <div></div>
          value: Number(country?.id),
          image: country?.flag,
        }))}
        defaultValue="194"
        {...props}
        clearable
        searchable
      />
    ),
    [countryData, props],
  );

  return <div>{SelectCountryCode}</div>;
};

export default CountryCodeSelect;
